import PaginationComponent from '@/components/common/PaginationComponent';
import QuestionsSkeleton from '@/components/molecules/question-list/QuestionsSkeleton';
import QuestionItem from '@/components/molecules/question-list/question-item';
import useRealtimeWebQnaViewModel from '@/features/qna/realtime-web/view-models/useRealtimeWebQnaViewModel';
import { ROUTES } from '@/types/common';
import Link from 'next/link';
import { Fragment } from 'react';

const RealtimeWebQna = ({ advertisementComponent }: { advertisementComponent: React.ReactNode }) => {
  const viewModel = useRealtimeWebQnaViewModel();
  return (
    <>
      {viewModel.isQnaListLoading ? (
        <QuestionsSkeleton />
      ) : (
        <ul>
          {viewModel.questions.map((qna, index) => (
            <Fragment key={`qna-${qna.question.questionPid}`}>
              <li>
                {index === 0 && advertisementComponent}
                <Link href={`${ROUTES.QNA.DETAIL.path}/${qna.question.questionPid}`}>
                  <a>
                    <QuestionItem questionCard={qna} onClickQuestion={() => {}} />
                  </a>
                </Link>
              </li>
            </Fragment>
          ))}
        </ul>
      )}
      <PaginationComponent
        totalPage={viewModel.totalPage}
        queries={viewModel.queries}
        baseUrl={ROUTES.QNA.REALTIME.path}
        currentPage={Number(viewModel.queries.page)}
        scroll={false}
        scrollRestoration={true}
      />
    </>
  );
};

export default RealtimeWebQna;
